import React, { createContext } from 'react'

const ListingTableContext = createContext({})

const ListingTableProvider = ({ listArr, all, rowsPerPage, children }) => {
  React.useEffect(() => {
      if (!!listArr) {
        setListingPage(0)
      }
      return () => setListingLoading(false)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const [listingRowsPerPage, setListingRowsPerPage] = React.useState(rowsPerPage || 10)
  const [listingLoading, setListingLoading] = React.useState(false)
  const [listingData, setListingData] = React.useState([])
  const [listingPage, setListingPage] = React.useState(-1)
  const [listingCount, setListingCount] = React.useState(listArr?.length || 0)


  React.useEffect(() => {
      if (listingPage > -1) {
        getListingData()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [listingPage, listingRowsPerPage])

  React.useEffect(() => {
      if (!!listArr) {
        getListingData()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [listArr])

  const handleChangeListingPage = (newPage) => {
    setListingPage(newPage)
  }

  const handleChangeListingRowsPerPage = (newRows) => {
    setListingRowsPerPage(+newRows)
    setListingPage(0)
  }

  const getListingData = () => {
    setListingLoading(true)
    if (!!listArr?.length) {
      setListingCount(listArr?.length)
      setListingData(!!all ? listArr : listArr.slice(listingPage * listingRowsPerPage, (listingPage + 1) * listingRowsPerPage))
    }
    setTimeout(() => setListingLoading(false), 500)
  }
  return (
    <ListingTableContext.Provider value={{
      listingData,
      listingLoading,

      listingCount,
      listingRowsPerPage,
      listingPage,
      handleChangeListingPage,
      handleChangeListingRowsPerPage,

    }}>
      {children}
    </ListingTableContext.Provider>
  )
}
const ListingTableConsumer = ListingTableContext.Consumer

export { ListingTableProvider, ListingTableConsumer }
